import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Dialog, MessagePlugin } from 'tdesign-react';
import doCopy from 'copy-to-clipboard';
import Form from '@/components/Form';
import CodeMirrorLight from '@/components/CodeMirrorLight';

export default function YamlToJson() {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);

  const from = Form.useWatch('from', form);
  const to = Form.useWatch('to', form);

  const onClick = () => setVisible(true);

  const doConvert = async () => {
    const YAML = await import('yaml');
    try {
      const json = YAML.parse(from || '');
      form.setFieldsValue({ to: json ? JSON.stringify(json, null, 2) : '' });
    } catch (error) {
      MessagePlugin.warning(`请检查YAML格式是否正确\n${error}`);
      throw error;
    }
  };

  const handleCopy = () => {
    doCopy(to);
    MessagePlugin.info('已拷贝');
  };

  return (
    <>
      <Button onClick={onClick} size='small' theme='primary' variant='outline'>
        YAML → JSON
      </Button>
      <Dialog
        header={
          <Line>
            <span>YAML → JSON</span>
            <Button variant='outline' size='small' theme='primary' onClick={handleCopy}>
              复制
            </Button>
          </Line>
        }
        visible={visible}
        onClose={() => setVisible(false)}
        width={'80%'}
        placement='center'
        footer={null}
        destroyOnClose
      >
        <Form form={form} initialValues={{ from: '\n'.repeat(10) }}>
          <Body>
            <Form.FormItem name={'from'} style={{ flex: 1 }}>
              <CodeMirrorLight placeholder='请输入YAML' type='yaml' />
            </Form.FormItem>
            <Center>
              <Button variant='outline' onClick={doConvert}>
                转换 →
              </Button>
            </Center>
            <Form.FormItem name={'to'} style={{ flex: 1 }}>
              <CodeMirrorLight placeholder='转换后的JSON' type='json' readOnly />
            </Form.FormItem>
          </Body>
        </Form>
      </Dialog>
    </>
  );
}

const Body = styled.div`
  display: flex;
  align-items: stretch;
  gap: 30px;
  .cm-theme-light {
    border-radius: 6px;
    height: 500px;
    box-sizing: border-box;
    .cm-editor {
    }
  }
  .t-form__item {
    margin-bottom: 0;
    min-width: 0;
    border: 1px solid var(--td-border-level-1-color);
    border-radius: 6px;
    overflow: hidden;
  }
`;

const Center = styled.div`
  display: flex;
  align-items: center;
`;

const Line = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
